import CreateTemplate from './partials/CreateTemplate';

export default CreateTemplate;
